import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '@/assets/smalt-home-logo.svg'
import _imports_1 from '@/assets/sidemenu-menu-icon.svg'
import _imports_2 from '@/assets/sidemenu-menu-icon-gray.svg'
import _imports_3 from '@/assets/edit-plus-active.svg'
import _imports_4 from '@/assets/edit-plus-inactive.svg'
import _imports_5 from '@/assets/users-v2.svg'
import _imports_6 from '@/assets/users-v2-gray.svg'
import _imports_7 from '@/assets/star-icon.svg'
import _imports_8 from '@/assets/user-icon.svg'
import _imports_9 from '@/assets/logout-redesign.svg'


const _hoisted_1 = { class: "md:flex flex-col relative w-[48px] h-full m-[2px] p-3 pl-[10px] bg-[#E5E4E2] rounded-[4px]" }
const _hoisted_2 = { class: "flex items-center gap-2" }
const _hoisted_3 = { class: "mt-[24px] flex flex-col items-start gap-2" }
const _hoisted_4 = {
  key: 0,
  class: "w-[24px] h-[24px]",
  src: _imports_1,
  alt: "Menu"
}
const _hoisted_5 = {
  key: 1,
  class: "w-[24px] h-[24px]",
  src: _imports_2,
  alt: "Menu"
}
const _hoisted_6 = {
  key: 0,
  class: "w-[18px] h-[18px]",
  src: _imports_3,
  alt: "Menu"
}
const _hoisted_7 = {
  key: 1,
  src: _imports_4,
  alt: ""
}
const _hoisted_8 = {
  key: 0,
  class: "w-[20px] h-[20px]",
  src: _imports_5,
  alt: "Menu"
}
const _hoisted_9 = {
  key: 1,
  src: _imports_6,
  alt: "Menu"
}
const _hoisted_10 = { class: "mt-auto flex flex-col items-start gap-[6px] justify-center" }
const _hoisted_11 = { class: "text-sm text-[#898790] font-semibold" }
const _hoisted_12 = {
  key: 0,
  class: "flex items-center w-[28px] h-[28px] justify-center m-auto rounded-full mb-[6px]"
}
const _hoisted_13 = ["src"]
const _hoisted_14 = {
  key: 1,
  class: "w-[20px] h-[20px] rounded-full border-[2px] border-[#898790]",
  src: _imports_8,
  alt: ""
}

import router from "@/router";
import { useUserStore } from "@/stores/user";
import { computed, ref, onMounted } from "vue";
import { useRoute, RouterLink } from "vue-router";
import client from "@/utils/axios";

type Emit = {
  (event: "onPhaseSelect", phaseId: number): void;
  (event: "selectStep", stepId: number): void;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'MainSidebar',
  emits: ["onPhaseSelect", "selectStep"],
  setup(__props) {

const userStore = useUserStore();
const route = useRoute();
const currentLang = ref(userStore.getCurrentLanguage);

const pictureUrl = ref(userStore.getAvatar);

onMounted(async () => {
  if (!pictureUrl.value) {
    try {
      const response = await client.get("/google-picture");
      pictureUrl.value = response.data.pictureUrl;
    } catch (error) {
      console.error("Error fetching Google picture:", error);
    }
  }
});



const logout = () => {
  userStore.logout();
  router.push("/login");
};

const activeMenu = computed(() => route.path);

const toggleLanguage = () => {
  let language = userStore.getCurrentLanguage;
  currentLang.value = language === "en" ? "de" : "en";
  userStore.changeLanguage(language === "en" ? "de" : "en");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(RouterLink), {
        to: "/",
        class: "w-[24px] h-[24px] flex items-center justify-center cursor-pointer"
      }, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createElementVNode("img", {
            src: _imports_0,
            alt: "Smalt icon"
          }, null, -1)
        ]))]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_unref(RouterLink), {
        to: "/",
        class: _normalizeClass(["group h-[28px] w-[28px] flex items-center justify-center bg-transparent rounded-primary-radius cursor-pointer hover:bg-[#d3d1cd] hover:shadow-[-4px_2px_4px_rgba(0,0,0,0.06)] duration-300", 
          activeMenu.value === '/' || activeMenu.value.toLowerCase().includes('projects')
            ? 'bg-white shadow-[-4px_2px_4px_rgba(0,0,0,0.06)]'
            : 'bg-transparent shadow-none'
        ])
      }, {
        default: _withCtx(() => [
          (
            activeMenu.value === '/' || activeMenu.value.toLowerCase().includes('projects')
          )
            ? (_openBlock(), _createElementBlock("img", _hoisted_4))
            : (_openBlock(), _createElementBlock("img", _hoisted_5))
        ]),
        _: 1
      }, 8, ["class"]),
      _createVNode(_unref(RouterLink), {
        to: "/build",
        class: _normalizeClass(["group h-[28px] w-[28px] flex items-center justify-center bg-transparent rounded-primary-radius cursor-pointer hover:bg-[#d3d1cd] hover:shadow-[-4px_2px_4px_rgba(0,0,0,0.06)] duration-300", 
          activeMenu.value.toLowerCase().includes('build')
            ? 'bg-white shadow-[-4px_2px_4px_rgba(0,0,0,0.06)]'
            : 'bg-transparent shadow-none'
        ])
      }, {
        default: _withCtx(() => [
          (activeMenu.value.toLowerCase().includes('build'))
            ? (_openBlock(), _createElementBlock("img", _hoisted_6))
            : (_openBlock(), _createElementBlock("img", _hoisted_7))
        ]),
        _: 1
      }, 8, ["class"]),
      _createVNode(_unref(RouterLink), {
        to: "/installers",
        class: _normalizeClass(["group h-[28px] w-[28px] flex items-center justify-center bg-transparent rounded-primary-radius cursor-pointer hover:bg-[#d3d1cd] hover:shadow-[-4px_2px_4px_rgba(0,0,0,0.06)] duration-300", 
          activeMenu.value.toLowerCase().includes('installers')
            ? 'bg-white shadow-[-4px_2px_4px_rgba(0,0,0,0.06)]'
            : 'bg-transparent shadow-none'
        ])
      }, {
        default: _withCtx(() => [
          (activeMenu.value.toLowerCase().includes('installers'))
            ? (_openBlock(), _createElementBlock("img", _hoisted_8))
            : (_openBlock(), _createElementBlock("img", _hoisted_9))
        ]),
        _: 1
      }, 8, ["class"]),
      _createVNode(_unref(RouterLink), {
        to: "/marketing/reviews",
        class: _normalizeClass(["group h-[28px] w-[28px] flex items-center justify-center bg-transparent rounded-primary-radius cursor-pointer hover:bg-[#d3d1cd] hover:shadow-[-4px_2px_4px_rgba(0,0,0,0.06)] duration-300", 
          activeMenu.value.toLowerCase().includes('marketing')
            ? 'bg-white shadow-[-4px_2px_4px_rgba(0,0,0,0.06)]'
            : 'bg-transparent shadow-none'
        ])
      }, {
        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
          _createElementVNode("img", {
            class: "w-[20px] h-[20px]",
            src: _imports_7,
            alt: "Marketing"
          }, null, -1)
        ]))]),
        _: 1
      }, 8, ["class"])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", null, [
        _createElementVNode("button", {
          onClick: toggleLanguage,
          class: "group h-[28px] w-[28px] flex items-center justify-center bg-transparent rounded-primary-radius cursor-pointer hover:bg-[#d3d1cd] hover:shadow-[-4px_2px_4px_rgba(0,0,0,0.06)] duration-300"
        }, [
          _createElementVNode("span", _hoisted_11, _toDisplayString(currentLang.value === "de" ? "EN" : "DE"), 1)
        ])
      ]),
      (pictureUrl.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            (pictureUrl.value)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  class: "w-[20px] h-[20px] rounded-full border-[2px] border-[#898790]",
                  src: pictureUrl.value,
                  alt: ""
                }, null, 8, _hoisted_13))
              : (_openBlock(), _createElementBlock("img", _hoisted_14))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("button", {
        onClick: logout,
        class: "group h-[28px] w-[28px] flex items-center justify-center bg-transparent rounded-primary-radius cursor-pointer hover:bg-[#d3d1cd] hover:shadow-[-4px_2px_4px_rgba(0,0,0,0.06)] duration-300"
      }, [...(_cache[2] || (_cache[2] = [
        _createElementVNode("img", {
          src: _imports_9,
          alt: "Logout"
        }, null, -1)
      ]))])
    ])
  ]))
}
}

})